import React, { FC } from 'react'
import IsoInfoContainer from 'containers/ISO/ISOInfo'

const IsoInfoPage: FC = () => <IsoInfoContainer />

export default IsoInfoPage
